import React, { useState, useEffect } from 'react';
import './AddDrawer.css';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import closeIcon from "../../assets/images/closeIcon.svg";
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodyExtraSmallRegular from '../designSystem/BodyExtraSmallRegular';
import tickIcon from "../../assets/images/tickIcon.svg";
import AddEventCard from './AddEventCard';
import deleteIcon_drawer from "../../assets/images/deleteIcon_drawer.svg";
import addIcon from "../../assets/images/addIcon.svg";
import { useDispatch, useSelector } from 'react-redux';
import { getTaskPracticeLocations } from '../../actions/userActions/tasks/taskAction';
import { addEmployeePlan, deletePlanVisits, updateEmployeePlan } from '../../actions/userActions/EmployeePlanAction';
import { getVisitProfileDetail } from '../../actions/userActions/VisitProfileAction';
import { getEmployee } from '../../actions/userActions/employeeAction';
import DeleteVisitModal from './DeleteVisitModal';
import { getCities } from '../../actions/userActions/cityAction';
import SingleSelect from '../designSystem/SingleSelect';
import VisitProfileModal from './VisitProfileModal';
import Textarea from '../designSystem/TextArea';
import Heading6Regular from '../designSystem/Heading6Regular';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import { t } from '../../locales/translate';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay'


const AddDrawer = ({ isOpen, onClose, day, events }) => {
    const permissions = JSON.parse(localStorage.getItem('permissionsList'));
    const [isDeleteVisitModalVisible, setIsDeleteVisitModalVisisble] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.result[0]?.user.id;
    const dispatch = useDispatch();
    const [isVisitProfileId, setIsVisitProfileId] = useState(false);
    const [disable, setDisable] = useState(false);
    const [visitProfileId, setVisitProfileId] = useState(null);
    const [errors, setErrors] = useState([]);
    const [deletePlanDetail, setDeletePlanDetail] = useState([]);
    const [deletePlanVisitsIds, setDeletePlanVisitsIds] = useState([]);
    const [updatedFormValues, setUpdatedFormValues] = useState();
    const [isVisitProfileModalVisible, setIsVisitProfileModalVisible] = useState(false);
    const [VisitProfileChange, setVisitProfileChange] = useState(null);
    const [isPracticeLocationsLoading, setIsPracticeLocationsLoading] = useState(false);
    const practiceLocations = useSelector(state => state.tasks_reducer.taskPracticeLocations);
    const addPlanStatus = useSelector(state => state.employeePlan_reducer.addEmployeePlan);
    const updateEmployeePlanStatus = useSelector(state => state.employeePlan_reducer.updateEmployeePlan);
    const deletePlanVisitsStatus = useSelector(state => state.employeePlan_reducer.deletePlanVisits);
    const visitProfileDetail = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
    const userDetail = useSelector((state) => state.employees_reducer.employee);
    const initialValues = {
        employeePlanId: 0,
        employeeId: userId,
        month: null,
        year: null,
        employeePlanDate: {
            employeePlanDateId: 0,
            planDate: null,
            visitProfileId: null,
            onLeave: false,
            leaveMessage: "",
            planDetails: [
                {
                    id: 0,
                    cityId: null,
                    startTime: null,
                    endTime: null,
                    practiceLocationId: null,
                    doctorId: null,
                    headOffice: false
                }
            ]
        }
    }
    const [isDeleteActive, setIsDeleteActive] = useState(false);
    const [formValues, setFormValues] = useState(initialValues);
    const [isSaving, setIsSaving] = useState(false); 

    const handleOnLeaveChange = (e) => {
        const isChecked = e.target.checked;
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDate: {
                ...prevValues.employeePlanDate,
                onLeave: isChecked,
                leaveMessage: isChecked ? prevValues.employeePlanDate.leaveMessage : "",
            }
        }));
        setDisable(false);
        setErrors([]);
    };

    const handleLeaveMessageChange = (e) => {
        const value = e.target.value;
        
        if (value.length > 150) {
            return;
        }
        
        setFormValues({
            ...formValues,
            employeePlanDate: {
                ...formValues.employeePlanDate,
                leaveMessage: value
            }
        });
        
        if (value.length === 150) {
            setErrors([{
                ...errors[0],
                leaveMessage: "Message cannot exceed 150 characters"
            }]);
        } else if (errors[0]?.leaveMessage) {
            setErrors([{
                ...errors[0],
                leaveMessage: ''
            }]);
        }
    };
    const addAnotherPlanDetail = () => {
        if (formValues.employeePlanDate.onLeave) return;

        if (permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerCity')) {
            setFormValues((prevValues) => ({
                ...prevValues,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDetails: [
                        ...prevValues.employeePlanDate.planDetails,
                        {
                            id: 0,
                            cityId: user?.result[0]?.user?.cityId,
                            startTime: null,
                            endTime: null,
                            practiceLocationId: null,
                            doctorId: null,
                            headOffice: false
                        }
                    ]
                }
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDetails: [
                        ...prevValues.employeePlanDate.planDetails,
                        {
                            id: 0,
                            cityId: null,
                            startTime: null,
                            endTime: null,
                            practiceLocationId: null,
                            doctorId: null,
                            headOffice: false
                        }
                    ]
                }
            }));
        }
        setDisable(false);
    };

    useEffect(() => {
    if (day) {
        const formattedDate = new Date(day.year, day.month - 1, day.day + 1).toISOString();
        if (permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerCity')) {
            setFormValues((prevValues) => ({
                ...prevValues,
                month: day.month,
                year: day.year,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDate: formattedDate,
                    planDetails: prevValues.employeePlanDate.onLeave ? [] : [
                        {
                            id: 0,
                            cityId: user?.result[0]?.user?.cityId,
                            startTime: null,
                            endTime: null,
                            practiceLocationId: null,
                            doctorId: null,
                            headOffice: false
                        }
                    ]
                }
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                month: day.month,
                year: day.year,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDate: formattedDate,
                    planDetails: prevValues.employeePlanDate.onLeave ? [] : [
                        {
                            id: 0,
                            cityId: user?.result[0]?.user?.cityId, // Add default city here too
                            startTime: null,
                            endTime: null,
                            practiceLocationId: null,
                            doctorId: null,
                            headOffice: false
                        }
                    ]
                }
            }));
        }
        setDisable(false);
    }
}, [day]);

    useEffect(() => {
    if (isOpen && events) {
        if (events.onLeave) {
            setFormValues((prevValues) => ({
                ...prevValues,
                employeePlanId: events.employeePlanId,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDate: events.planDate,
                    employeePlanDateId: events.id,
                    visitProfileId: events?.visitProfile?.visitProfileId || null,
                    onLeave: true,
                    leaveMessage: events.leaveMessage || "",
                    // Keep plan details even if onLeave - don't clear them
                    planDetails: events.planDetails && events.planDetails.length > 0 ? [
                        ...events.planDetails.map((detail) => ({
                            id: detail.id || 0,
                            cityId: detail.cityId || user?.result[0]?.user?.cityId,
                            startTime: detail.startTime || null,
                            endTime: detail.endTime || null,
                            practiceLocationId: detail.practiceLocationId || null,
                            doctorId: detail.doctorId || null,
                            headOffice: detail.headOffice || false
                        }))
                    ] : [{
                        id: 0,
                        cityId: user?.result[0]?.user?.cityId,
                        startTime: null,
                        endTime: null,
                        practiceLocationId: null,
                        doctorId: null,
                        headOffice: false
                    }]
                }
            }));
            } else if (events.planDetails && events.planDetails.length > 0) {
            setFormValues((prevValues) => ({
                ...prevValues,
                employeePlanId: events.employeePlanId,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDate: events.planDate,
                    employeePlanDateId: events.id,
                    visitProfileId: events?.visitProfile?.visitProfileId || null,
                    onLeave: events.onLeave || false,
                    leaveMessage: events.leaveMessage || "",
                    planDetails: [
                        ...events.planDetails.map((detail) => ({
                            id: detail.id || 0,
                            cityId: detail.cityId || user?.result[0]?.user?.cityId,
                            startTime: detail.startTime || null,
                            endTime: detail.endTime || null,
                            practiceLocationId: detail.practiceLocationId || null,
                            doctorId: detail.doctorId || null,
                            headOffice: detail.headOffice || false
                        }))
                    ]
                }
            }));
        }
            setDisable(true);
            if (events?.visitProfile?.visitProfileId) {
                setVisitProfileId(events?.visitProfile?.visitProfileId);
                setIsVisitProfileId(true);
            }
        }
    }, [events, day, isOpen]);

    const formattedDate = day
        ? new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(new Date(day.year, day.month - 1, day.day))
        : '';

    useEffect(() => {
    if (user && user.result[0]?.user) {
        if (visitProfileId && isVisitProfileId) {
            dispatch(getVisitProfileDetail(visitProfileId));
        } else if (!isVisitProfileId) {
            if (!permissions.includes('CanViewPlannerCity') || 
                (permissions.includes('CanAddPlannerCity') && permissions.includes('CanAddPlannerLocation'))) {
                setIsPracticeLocationsLoading(true);
                dispatch(getTaskPracticeLocations(user.result[0].user.cityId));
            }
        }
    }
}, [userId, dispatch, isVisitProfileId, visitProfileId]);

useEffect(() => {
    if (practiceLocations && practiceLocations !== "isLoading") {
        setIsPracticeLocationsLoading(false);
    }
}, [practiceLocations]);
    const updatePlanDetail = (index, updatedDetail) => {
        setFormValues((prevValues) => {
            const updatedPlanDetails = [...prevValues.employeePlanDate.planDetails];
            updatedPlanDetails[index] = {
                ...updatedPlanDetails[index],
                ...updatedDetail,
            };
            return {
                ...prevValues,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDetails: updatedPlanDetails,
                },
            };
        });
        setDisable(false);
        setErrors([]);
    };

    const validatePlanDetails = () => {
        const newErrors = [];

        if (formValues.employeePlanDate.onLeave) {
            if (!formValues.employeePlanDate.leaveMessage || formValues.employeePlanDate.leaveMessage.trim() === "") {
                setErrors([{ leaveMessage: 'Leave message is required when on leave' }]);
                return false;
            }
            return true;
        }

        if (formValues.employeePlanId !== 0) {
            const planDetails = formValues.employeePlanDate.planDetails;
            const allDetailsEmpty = planDetails.every(detail =>
                !detail.practiceLocationId &&
                !detail.doctorId &&
                !detail.startTime &&
                !detail.endTime &&
                (!detail.cityId || detail.cityId === null)
            );

            if (allDetailsEmpty) {
                return true;
            }
        }
        const planDetails = formValues.employeePlanDate.planDetails;

        planDetails.forEach((detail, index) => {
            const detailErrors = {};

            if (permissions && permissions.includes('CanAddPlannerLocation') && !detail.practiceLocationId) {
                detailErrors.practiceLocationId = 'Practice Location is required';
            }
            if (permissions && permissions.includes('CanAddPlannerDoctor') && !detail.doctorId) {
                detailErrors.doctorId = 'Doctor is required';
            }
            if (permissions && permissions.includes('CanAddPlannerTime') && !detail.startTime) {
                detailErrors.startTime = 'Start time is required';
            }
            if (permissions && permissions.includes('CanAddPlannerTime') && !detail.endTime) {
                detailErrors.endTime = 'End time is required';
            }
            if (permissions && permissions.includes('CanAddPlannerTime') && detail.startTime && detail.endTime && detail.startTime >= detail.endTime) {
                detailErrors.endTime = 'End time invalid';
            }
            if (permissions && permissions.includes('CanAddPlannerCity') && !detail.cityId && !detail.headOffice) {
                detailErrors.cityId = 'City is required';
            }

            // Overlap validation
            planDetails.forEach((otherDetail, otherIndex) => {
                if (index !== otherIndex && otherDetail.startTime && otherDetail.endTime) {
                    const otherStart = otherDetail.startTime;
                    const otherEnd = otherDetail.endTime;

                    // Check for start time overlap
                    if (detail.startTime >= otherStart && detail.startTime < otherEnd) {
                        detailErrors.startTime = 'Start time overlap';
                    }

                    // Check for end time overlap
                    if (detail.endTime > otherStart && detail.endTime <= otherEnd) {
                        detailErrors.endTime = 'End time overlap';
                    }

                    // Check for complete overlap (current detail spans the other detail)
                    if (detail.startTime <= otherStart && detail.startTime >= otherEnd) {
                        detailErrors.startTime = 'Start time overlap';
                        detailErrors.endTime = 'End time overlap';
                    }
                }
            });

            if (Object.keys(detailErrors).length > 0) {
                newErrors[index] = detailErrors;
            }
        });

        setErrors(newErrors);
        return newErrors.length === 0;
    };
    const handleSave = () => {
    if (formValues && formValues.employeePlanId !== 0 && formValues.employeePlanDate.planDetails[0]?.cityId === "clear") {
        const updatedDeleteFormValues = {
            ...formValues,
            employeePlanDate: {
                ...formValues.employeePlanDate,
                planDetails: [],
            },
        };
        setIsSaving(true); 
        dispatch(updateEmployeePlan(updatedDeleteFormValues));
    }
    if (validatePlanDetails()) {
        
        const planDetails = formValues.employeePlanDate.planDetails;
        const allDetailsEmpty = planDetails.every(detail =>
            !detail.practiceLocationId &&
            !detail.doctorId &&
            !detail.startTime &&
            !detail.endTime &&
            (!detail.cityId || detail.cityId === null) &&
            !detail.headOffice
        );

        const payloadFormValues = {
            ...formValues,
            employeePlanDate: {
                ...formValues.employeePlanDate,
                planDetails: formValues.employeePlanDate.onLeave || allDetailsEmpty ? [] : formValues.employeePlanDate.planDetails
            }
        };

        setIsSaving(true); 

        if (payloadFormValues && payloadFormValues.employeePlanId && payloadFormValues.employeePlanId != 0) {
            dispatch(updateEmployeePlan(payloadFormValues));
        } else {
            dispatch(addEmployeePlan(payloadFormValues));
        }
    }
};

    const handleClose = () => {
        setFormValues(initialValues);
        setErrors([]);
        setUpdatedFormValues([]);
        setDeletePlanDetail([]);
        setIsDeleteActive(false);
        onClose();
    };
    useEffect(() => {
    if ((addPlanStatus && addPlanStatus !== "isLoading" && addPlanStatus === true) || (updateEmployeePlanStatus && updateEmployeePlanStatus !== "isLoading" && updateEmployeePlanStatus === true)) {
        setIsSaving(false); 
        handleClose();
        setIsDeleteVisitModalVisisble(false);
        setDeletePlanDetail([]);
        setIsDeleteActive(false);
    }
}, [addPlanStatus, updateEmployeePlanStatus]);

    useEffect(() => {
        if (deletePlanVisitsStatus && deletePlanVisitsStatus !== "isLoading" && deletePlanVisitsStatus === true) {
            setFormValues(updatedFormValues);
            setIsDeleteVisitModalVisisble(false);
            setIsDeleteActive(false);
            setDeletePlanDetail([]);
            handleClose();
        }
    }, [deletePlanVisitsStatus]);

    useEffect(() => {
        if (userId) {
            dispatch(getEmployee(userId));
        }
        if (permissions && permissions.includes('CanAddPlannerCity')) {
            const cityBody = {
                filter: {
                    textSearch: "",
                    countryId: "1"
                },
                pageNumber: -1,
                pageSize: 0,
            };
            dispatch(getCities(cityBody));
        }
    }, [userId]);
    const handleSelectChange = (event, fieldName) => {
        if (fieldName === 'visitProfileId') {
            setVisitProfileChange(event.value);

            if (formValues.employeePlanDate &&
                formValues.employeePlanDate.visitProfileId &&
                formValues.employeePlanDate.planDetails &&
                formValues.employeePlanDate.planDetails.length > 0 &&
                formValues.employeePlanDate.planDetails.some(detail =>
                    detail.practiceLocationId && detail.doctorId)
            ) {
                setIsVisitProfileModalVisible(true);
            } else {
                applyVisitProfileChange(event.value);
            }
        }
    };

    const applyVisitProfileChange = (selectedVisitProfileId) => {
    setVisitProfileId(selectedVisitProfileId);
    setIsVisitProfileId(selectedVisitProfileId ? true : false);

   
    if (selectedVisitProfileId) {
        dispatch(getVisitProfileDetail(selectedVisitProfileId));
    }

    const emptyPlanDetail = {
        id: 0,
        cityId: null, 
        startTime: null,
        endTime: null,
        practiceLocationId: null,
        doctorId: null,
        headOffice: false
    };

    setFormValues(prevValues => ({
        ...prevValues,
        employeePlanDate: {
            ...prevValues.employeePlanDate,
            visitProfileId: selectedVisitProfileId,
            planDetails: prevValues.employeePlanDate.onLeave ? [] : [emptyPlanDetail]
        },
    }));

    setDisable(false);
};
    const closeVisitProfileModal = () => {
        setIsVisitProfileModalVisible(false);
        setVisitProfileChange(null);
    };

    const confirmVisitProfileChange = () => {
        if (VisitProfileChange !== null) {
            applyVisitProfileChange(VisitProfileChange);
        }
        setIsVisitProfileModalVisible(false);
        setVisitProfileChange(null);
    };
    const getOptions = (fieldName) => {
        if (fieldName === 'visitProfileId') {
            const visitProfiles = userDetail?.visitProfiles || user?.result[0]?.user?.visitProfiles || [];
            return visitProfiles.map(profile => ({
                value: profile.visitProfileId,
                label: profile.profileName
            }));
        }
        return [];
    };

    const onDeleteVisitModalClose = () => {
        setIsDeleteVisitModalVisisble(!isDeleteVisitModalVisible);
    };

    const handleToggleCheckbox = (index, isChecked) => {
        setDeletePlanDetail((prevState) => {
            if (isChecked) {
                return [...prevState, index];
            } else {
                return prevState.filter((item) => item !== index);
            }
        });
    };
    const handleDeleteConfirm = async () => {
    if (deletePlanVisitsIds && deletePlanVisitsIds.length !== 0) {
        const body = {
            "planDetailIds": deletePlanVisitsIds,
            "employeeId": userId
        }
        await dispatch(deletePlanVisits(body));
    } else if (updatedFormValues && updatedFormValues.length !== 0) {
        setFormValues(updatedFormValues);
        setIsDeleteVisitModalVisisble(false);
        setIsDeleteActive(false);
        setDeletePlanDetail([]);
    }
};
    const handleDelete = () => {
        if (deletePlanDetail.length > 0) {
            if (
                formValues &&
                formValues.employeePlanDate &&
                formValues.employeePlanDate.planDetails
            ) {
                const deletePlanVisitsIds = [];
                formValues.employeePlanDate.planDetails.forEach((item, index) => {
                    if (deletePlanDetail.includes(index) && item.id !== null && item.id !== 0) {
                        deletePlanVisitsIds.push(item.id);
                    }
                })
                const updatedPlanDetails = formValues.employeePlanDate.planDetails.filter(
                    (_, index) => !deletePlanDetail.includes(index)
                );
                if (updatedPlanDetails && updatedPlanDetails.length === 0) {
                    setUpdatedFormValues({
                        ...formValues,
                        employeePlanId: 0,
                        employeePlanDate: {
                            ...formValues.employeePlanDate,
                            employeePlanDateId: 0,
                            planDetails: updatedPlanDetails,
                        },
                    });
                } else {
                    setUpdatedFormValues({
                        ...formValues,
                        employeePlanDate: {
                            ...formValues.employeePlanDate,
                            planDetails: updatedPlanDetails,
                        },
                    });
                }
                setDeletePlanVisitsIds(deletePlanVisitsIds);
                setIsDeleteVisitModalVisisble(true);
            }
        }
    };

    useEffect(() => {
        if (userDetail && userDetail !== "isLoading" && userDetail.length !== 0) {
            if (userDetail && userDetail.visitProfiles.length !== 0) {
                setIsVisitProfileId(true);
            }
        }
    }, [userDetail]);
    
useEffect(() => {
    if (isVisitProfileId && visitProfileId && visitProfileDetail && 
        visitProfileDetail !== "isLoading" && visitProfileDetail.result?.[0]) {
        
        const profileCityId = visitProfileDetail.result[0]?.cityId;
        
        if (profileCityId && formValues.employeePlanDate.visitProfileId === visitProfileId) {
           
            setFormValues(prevValues => ({
                ...prevValues,
                employeePlanDate: {
                    ...prevValues.employeePlanDate,
                    planDetails: prevValues.employeePlanDate.planDetails.map(detail => ({
                        ...detail,
                        cityId: profileCityId,
                        practiceLocationId: null,
                        doctorId: null
                    }))
                }
            }));
        }
    }
}, [visitProfileDetail, visitProfileId, isVisitProfileId, formValues.employeePlanDate.visitProfileId]);
useEffect(() => {
    if (permissions && permissions.includes('CanAddPlannerCity') && permissions.includes('CanAddPlannerLocation')) {
        formValues.employeePlanDate.planDetails.forEach((planDetail) => {
            if (planDetail.cityId && planDetail.cityId !== "clear") {
                setIsPracticeLocationsLoading(true);
                dispatch(getTaskPracticeLocations(planDetail.cityId));
            }
        });
    }
}, [formValues.employeePlanDate.planDetails.map(detail => detail.cityId).join(',')]);
    return (
        <>
            <div
                className={`add-drawer-backdrop ${isOpen ? 'open' : ''}`}
                onClick={handleClose}
            ></div>

            <div className={`add-drawer-container ${isOpen ? 'open' : ''}`}>
                <LoadingOverlay isVisible={isSaving} />
                <div className="add-drawer-header">
                    <BodyLargeMedium text={formattedDate} color='#384153' />
                    <button
                        disabled={addPlanStatus === "isLoading" || updateEmployeePlanStatus === "isLoading" || (!formValues.employeePlanDate.onLeave && formValues.employeePlanDate?.planDetails?.length === 0)}
                        className={`save-button ${disable ? 'disabled' : ''}`}
                        onClick={handleSave}
                         style={document.body.dir === "rtl" ? { width: '123px' } : {}}
                    >
                        <img src={tickIcon} alt="tick icon" />
                         <Heading6Regular text={t("save")} color="#FFFFFF" />
                    </button>
                    {(permissions && !permissions.includes('CanAddPlannerTime')) || isDeleteActive && (
                        <button className='close-icon-button' onClick={() => setIsDeleteActive(false)}>
                            <img src={closeIcon} />
                        </button>
                    )}
                    {permissions && permissions.includes('CanAddPlannerLocation') && permissions.includes('CanAddPlannerTime') && !isDeleteActive && (
                        <button className='delete-icon-button' onClick={() => setIsDeleteActive(true)}>
                            <img src={deleteIcon_drawer} />
                        </button>
                    )}
                </div>
                <div className='add-drawer-main'>
                    {isVisitProfileId && (
                        <div className="visit-profile-select-container">
                            <SingleSelect
                                label={t("visitProfile")}
                                isSearchable
                                iconEnd
                                onChange={(event) => handleSelectChange(event, 'visitProfileId')}
                                value={formValues.employeePlanDate.visitProfileId}
                                placeholder="Select Visit Profile"
                                options={getOptions("visitProfileId")}
                            />
                        </div>
                    )}

                    <div className='on-leave-row' style={{ margin: '16px 0' }}>
                        <input
                            type="checkbox"
                            className='on-leave-checkbox'
                            checked={formValues.employeePlanDate.onLeave}
                            onChange={handleOnLeaveChange}
                        />
                        <BodySmallMedium text={t("onLeave")} color="#6B7280" />
                    </div>

                    {formValues.employeePlanDate.onLeave && (
                        <div className="leave-message-container">
                            <Textarea
                                height='85px'
                                width='250px'
                                name="leaveMessage"
                                label={t("leaveMessage")}
                                placeholder={t("enterLeaveMessage")}
                                value={formValues.employeePlanDate.leaveMessage}
                                onChange={handleLeaveMessageChange}
                                error={errors[0]?.leaveMessage}
                            />
                            <div className="character-counter">
                                {formValues.employeePlanDate.leaveMessage.length}/150
                            </div>
                        </div>
                    )}

                    <VisitProfileModal
                        isVisible={isVisitProfileModalVisible}
                        onClose={closeVisitProfileModal}
                        onConfirm={confirmVisitProfileChange}
                        isLoading={false}
                    />

                    {formValues.employeePlanDate.planDetails.map((planDetail, index) => (
    <AddEventCard
        key={index}
        isDeleteActive={isDeleteActive}
        planDetail={planDetail}
        practiceLocations={practiceLocations}
        isVisitProfileId={isVisitProfileId}
        onUpdatePlanDetail={updatePlanDetail}
        index={index}
        errors={errors[index] || {}}
        formValues={formValues}
        isChecked={deletePlanDetail.includes(index)}
        onToggleCheckbox={handleToggleCheckbox}
        isOnLeave={formValues.employeePlanDate.onLeave}
        isPracticeLocationsLoading={isPracticeLocationsLoading}
    />
))}

                    {((formValues.employeePlanId && formValues.employeePlanId !== 0) || !formValues.employeePlanDate.onLeave) && permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerLocation') && !isDeleteActive && (
                        <button className='add-another-button' onClick={addAnotherPlanDetail}>
                            <img src={addIcon} />
                            <Heading6Regular text={t("addAnother")} color='#1E293B' />
                        </button>
                    )}
                </div>
                {isDeleteActive && (
                    <div className='footer-button-container'>
                        <button className='cancel-button'
                            onClick={() => {
                                setIsDeleteActive(false);
                                setDeletePlanDetail([]);
                            }}
                        >
                            <span style={{color: '#1E293B', fontSize: '16px', fontWeight: 400}}>Cancel</span>
                        </button>
                        <button
                            className={`delete-button ${deletePlanDetail.length === 0 ? 'opacity-70 cursor-not-allowed' : ''}`}
                            onClick={handleDelete} disabled={deletePlanDetail.length === 0}>
                            <span style={{color: '#FFFFFF', fontSize: '16px', fontWeight: 400}}>Delete</span>
                        </button>
                    </div>
                )}
            </div>
            <DeleteVisitModal isLoading={deletePlanVisitsStatus === "isLoading"} onDeleteClick={handleDeleteConfirm} isVisible={isDeleteVisitModalVisible} onClose={onDeleteVisitModalClose} />
        </>
    );
};

export default AddDrawer;